import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "jspdf-autotable";
import ClassReportTabs from "./DetailCoursesBlocks/OnlineClassesBlocks/ClassReportTabs";
import { GetClassParticipants } from "../../services/CourseService";

const ClassReport = () => {
  const { subTab } = useParams();
  const [loading, setLoading] = useState(false)
  const [classReport, setClassReport] = useState([]);
  const getClassData = () => {
    GetClassParticipants(subTab)
      .then((res) => {
        let tempArr = [res.data]
        setClassReport(tempArr);
        setLoading(true)
      })
      .catch((err) => {
        console.log(err);
        setLoading(true)
      });

  }


  useEffect(() => {
    getClassData();
  }, []);

  return (
    <div>
      <ClassReportTabs />
    </div>
  );
};

export default ClassReport;
